import { useQuery } from '@tanstack/react-query';
import { reportService } from '@/services/reportService';

export function useTripIssues(tripId) {
  return useQuery({
    queryKey: ['tripIssues', tripId],
    queryFn: async () => {
      const result = await reportService.getTripIssues(tripId);
      if (!result.success) throw new Error(result.error);
      return { issues: result.issues, pagination: result.pagination };
    },
    enabled: !!tripId,
  });
}
